import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

export interface ISegment {
    label: string;
}

export interface IDemandsIndexChangeEvent {
    newStepIndex: number;
}

@Component({
    selector: 'nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent {
    @Input()
    public segments: ISegment[];
    public hoverIndex: number = -1;

    /** The index of the segment the user is currently viewing. */
    @Input()
    public activeIndex: number = 0;

    /** The index of the segment which represents the current progress / step. */
    @Input()
    public currentIndex: number = 0;

    /** The index of the segment the user could possibly skip to. */
    @Input()
    public skipAllowedIndex: number = 0;

    @Output()
    public demandsIndexChange = new EventEmitter<IDemandsIndexChangeEvent>();

    public segment_click(segment: ISegment, index: number) {
        if (index > this.skipAllowedIndex)
            return;

        if (this.activeIndex !== index) {
            this.demandsIndexChange.emit({ newStepIndex: index });
            this.activeIndex = index;
        }
    }

    public segment_mouseover(index: number) {
        this.hoverIndex = index;
    }

    public segment_mouseout(index: number) {
        this.hoverIndex = -1;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/nav-bar/nav-bar.component.ts